export default __webpack_public_path__ + "static/media/AGBs.8fadd952.md";